import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { useI18n } from '@hydra/common/customHooks';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ProjectShell from '@hydra/common/shell/ProjectShell';

import { getReviewData } from '@hydra/utils/reviewApi';
import { getFavicon } from '@hydra/utils/getFavicon';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
});

export default function CrawlerContainer ({ children, params }) {
  const [favicon, setFavicon] = useState('');
  useEffect(() => {
    async function getReview (url) {
      const review = await getReviewData({ url, criteria: 'favicon' });
      const icon = getFavicon(review);
      setFavicon(icon);
    }
    if (params && params.url) {
      getReview(params.url);
    }
  }, [params]);

  const classes = useStyles();
  const theme = useTheme();
  const { translate } = useI18n();
  return (
    <>
      <Helmet>
        <title>{`WooRank | ${translate('crawler')} | ${translate('baseline')}`}</title>
      </Helmet>
      <ProjectShell
        favicon={favicon || null}
        className={classes.root}
        section='crawler'
        bgColor={theme.palette.background.secondary}
      >
        {children}
      </ProjectShell>
    </>
  );
}

CrawlerContainer.propTypes = {
  children: PropTypes.element
};
